<template>
  <v-card class="rsl-fixed-height-external">
    <v-container>
      Please wait...
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'oauthcallback',
  computed: {
      ...mapGetters(['apiReturnData']),
  },
  data: function() {
    return {

    }
  },
  mounted() {
    let url = new URL(window.location.toLocaleString());
    let code = url.searchParams.get('code');
    
    this.$store.commit('API_AUTH_CODE', code);
    
    window.close();
  }
}
</script>